import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Contact from './components/Contact';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <footer className="bg-blue-900 text-white p-4 text-center mt-6">
        <p>&copy; 2025 SopoTec | Cel: +503 74940422 | Alexis Flores <a href="mailto:ajflores.290992@gmail.com" className="text-orange-500 hover:text-orange-600">ajflores.290992@gmail.com</a></p>
        <p><a href="https://www.linkedin.com/in/alexis-flores-483389107" target="_blank" rel="noopener noreferrer" className="text-orange-500 hover:text-orange-600">LinkedIn</a></p>
      </footer>
    </Router>
  );
}

export default App;